export type ProductCategory = 'Package' | 'Flight' | 'Hotel' | 'Tour' | 'Visa' | 'Transfer' | 'Insurance' | 'Cruise';
export type ProductStatus = 'Active' | 'Inactive' | 'Sold Out';

export interface ProductInclusion {
  id: string;
  text: string;
}

export interface Product {
  id: string;
  category: ProductCategory;
  name: string;
  destination: string;
  duration: string;
  description: string;
  image: string;
  status: ProductStatus;
  currency: string;
  costPrice: number;
  sellPrice: number;
  minPax: number;
  maxPax: number;
  inclusions: string[];
  exclusions: string[];
  supplierName: string;
  supplierContact: string;
  supplierRef: string;
  timesBooked: number;
  rating: number;
  tags: string[];
  featured: boolean;
  availableFrom: string;
  availableTo: string;
}

export const categoryConfig: Record<ProductCategory, { color: string; icon: string; bg: string }> = {
  Package:   { color: '#0D9488', icon: 'ri-suitcase-line',        bg: '#F0FDFA' },
  Flight:    { color: '#0891B2', icon: 'ri-flight-takeoff-line',  bg: '#F0F9FF' },
  Hotel:     { color: '#D97706', icon: 'ri-hotel-line',           bg: '#FFFBEB' },
  Tour:      { color: '#059669', icon: 'ri-map-2-line',           bg: '#ECFDF5' },
  Visa:      { color: '#DC2626', icon: 'ri-passport-line',        bg: '#FEF2F2' },
  Transfer:  { color: '#7C3AED', icon: 'ri-car-line',             bg: '#F5F3FF' },
  Insurance: { color: '#0F766E', icon: 'ri-shield-check-line',    bg: '#F0FDFA' },
  Cruise:    { color: '#0E7490', icon: 'ri-ship-line',            bg: '#ECFEFF' },
};

export const productsData: Product[] = [];
